import type { LineSeriesOption, XAXisComponentOption, YAXisComponentOption } from 'echarts';

import { PLOT_GRID_INDEX } from '../../config/chartLayout';
import { TOOLTIP_ANCHOR_SERIES_ID } from '../../config/componentIds';

export type TooltipAnchorOption = {
  xAxis: XAXisComponentOption;
  yAxis: YAXisComponentOption;
  series: LineSeriesOption;
};

type BuildTooltipAnchorOptionParams = {
  xAxisIndex: number;
  yAxisIndex: number;
};

/** Invisible 0..1 axes on the plot grid; they are not part of the data zoom, so nothing filters them. */
function buildHiddenAxis(): XAXisComponentOption & YAXisComponentOption {
  return {
    type: 'value',
    gridIndex: PLOT_GRID_INDEX,
    min: 0,
    max: 1,
    show: false,
    axisPointer: { show: false },
  };
}

/**
 * The nearest-series tooltip is shown with `showTip` on this series. Its content comes from the
 * renderer's own cards and its position follows the cursor, so the anchor carries no information;
 * it only has to exist and stay resolvable regardless of sampling and the current viewport.
 */
export function buildTooltipAnchorOption({
  xAxisIndex,
  yAxisIndex,
}: BuildTooltipAnchorOptionParams): TooltipAnchorOption {
  return {
    xAxis: buildHiddenAxis(),
    yAxis: buildHiddenAxis(),
    series: {
      id: TOOLTIP_ANCHOR_SERIES_ID,
      type: 'line',
      xAxisIndex,
      yAxisIndex,
      data: [[0.5, 0.5]],
      silent: true,
      showSymbol: true,
      symbolSize: 0,
      lineStyle: { opacity: 0 },
      itemStyle: { opacity: 0 },
      emphasis: { disabled: true },
    },
  };
}
